module.exports = __webpack_public_path__ + "img/baby-breech-footling.72c4f5a7.png";